module.exports = __webpack_public_path__ + "img/08—01—01—Diagnostic information.874e7e04.jpg";